import React from "react"
import styled from "styled-components"

import { minWidth } from "utils"

import Icon from "icons"

export const Container = styled.div`
  padding: 6rem 2rem;
  background-color: #fff;
`

export const DesktopWrapper = styled.div`
  display: none;

  ${minWidth.tablet`
    display: block;
  `}
`

export const MobileWrapper = styled.div`
  ${minWidth.tablet`
    display: none;
  `}
`

export const PreTitleDesktop = styled.h3`
  margin-bottom: 2rem;
  color: ${({ theme }) => theme.colors.primaryOrange};
  font-size: 1.2rem;
  font-weight: 500;
  line-height: 1.62rem;
  letter-spacing: 0.2rem;
  text-transform: uppercase;
`

export const PreTitleMobileWrapper = styled.div`
  display: flex;
`

export const PreTitleLine = styled.span`
  width: 100%;
  height: 0.1rem;
  margin-top: 0.7rem;
  display: inline-block;
  vertical-align: middle;
  background-color: #d0d0d0;
`

export const PreTitleMobile = styled(PreTitleDesktop)`
  margin: 0 1.5rem 3rem;
  color: #222;
`

export const PreTitle = ({ ...props }) => (
  <>
    <DesktopWrapper>
      <PreTitleDesktop {...props} />
    </DesktopWrapper>
    <MobileWrapper>
      <PreTitleMobileWrapper>
        <PreTitleLine />
        <PreTitleMobile {...props} />
        <PreTitleLine />
      </PreTitleMobileWrapper>
    </MobileWrapper>
  </>
)

export const Title = styled.h1`
  font-size: 2rem;
  font-weight: 400;
  line-height: 3.24rem;

  ${minWidth.tablet`
    max-width: 45%;
    font-size: 3.2rem;
    line-height: 4.32rem;
  `}
`

export const DescriptionRow = styled.div`
  margin-bottom: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  column-gap: 2rem;

  ${minWidth.tablet`
    flex-direction: row;
    align-items: flex-end;
  `}
`

export const Description = styled.p`
  font-size: 1.6rem;
  line-height: 2.496rem;

  ${minWidth.tablet`
    padding-right: 2rem;
  `}
`

export const List = styled.div`
  margin-top: 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  column-gap: 1rem;

  ${minWidth.tablet`
    margin-top: 0;
    flex-direction: row;
  `}
`

export const ListItem = styled.div`
  display: flex;

  ${minWidth.tablet`
    width: 33.3333%;
    display: block;
  `}
`

export const ListItemIcon = styled(Icon)`
  color: #222;
`

export const ListItemText = styled.p`
  margin: 0 0 0 2rem;
  font-size: 1.6rem;
  line-height: 2.496rem;

  ${minWidth.tablet`
    margin: 1rem 0;
  `}
`

export const NextCourses = styled.h3`
  margin-bottom: 1.5rem;
  color: #767676;
  font-size: 1.6rem;
  font-weight: 400;
  line-height: 2.496rem;
`

export const Courses = styled.div`
  display: flex;
  justify-content: space-between;
`

export const CourseWrapper = styled.div`
  position: relative;
  width: 31.6rem;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  padding: 2rem;
  background-color: #003445;

  &:first-of-type {
    margin-left: 0;
  }

  &:last-of-type {
    margin-right: 0;
  }

  ${minWidth.tablet`
    width: calc(33% - 1rem);
    padding: 2.8rem;
  `}
`

export const CourseTitle = styled.h3`
  color: #fff;
  font-size: 1.8rem;
  font-weight: 400;
  line-height: 3.24rem;

  ${minWidth.tablet`
  font-size: 2.4rem;
  `}
`

export const CourseSubtitle = styled.p`
  color: #fff;
  font-size: 1.2rem;
  line-height: 2.184rem;

  ${minWidth.mobile`
    font-size: 1.4rem;
  `}
`

export const CourseList = styled.div`
  margin: 3rem 0 5.6rem;
  display: grid;
  grid-template-columns: 1fr;
  column-gap: 3.5rem;
  row-gap: 1.5rem;

  ${minWidth.desktopL`
    grid-template-columns: repeat(2, 1fr);
  `}
`

export const CourseListItem = styled.div`
  display: flex;
`

export const CourseListItemIcon = styled(Icon)`
  width: 2.4rem;
  height: 2.4rem;
  margin-top: -0.5rem;
  margin-right: 0.5rem;
  color: #fff;
`

export const CourseListItemTitle = styled.h4`
  color: #fff;
  font-size: 1.1rem;
  font-weight: 500;
  line-height: 1.62rem;
  letter-spacing: 0.2rem;
  text-transform: uppercase;

  ${minWidth.tablet`
    font-size: 1.2rem;
  `}
`

export const CourseListItemText = styled.p`
  color: #fff;
  line-height: 2.496rem;
  font-size: 1.2rem;

  ${minWidth.mobile`
    font-size: 1.4rem;
  `}

  ${minWidth.tablet`
    font-size: 1.6rem;
  `}
`

export const CourseLink = styled.a`
  position: absolute;
  bottom: 3.6rem;
  left: 2rem;
  right: 2rem;
  padding: 1rem 1.5rem;
  background-color: ${({ theme }) => theme.colors.primaryOrange};
  color: #fff;
  border-radius: 5rem;
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 1.89rem;
  letter-spacing: 0.1rem;
  text-align: center;
  text-transform: uppercase;

  ${minWidth.tablet`
    left: 50%;
    right: unset;
    transform: translateX(-50%);
  `}
`

const ScrollLabel = styled.div`
  margin-top: 3.5rem;
  font-size: 1.6rem;
  line-height: 2.2rem;
`

const ScrollArrowLineMobile = styled(Icon)`
  ${minWidth.mobile`
    display: none;
  `}
`

const ScrollArrowLineDesktop = styled(Icon)`
  display: none;

  ${minWidth.mobile`
    display: block;
  `}
`

export const ScrollLabelWithArrow = () => (
  <>
    <ScrollLabel>Next courses</ScrollLabel>
    <ScrollArrowLineMobile viewBox="0 0 348 12" id="arrow-line-mobile" />
    <ScrollArrowLineDesktop viewBox="0 0 823 12" id="arrow-line-desktop" />
  </>
)

export const ScrollContainer = styled.div`
  width: 100%;
  margin: 1rem 0 3rem;
`

export const ScrollableGrid = styled.div`
  display: -webkit-box;
  overflow-x: auto;
`

export const ExploreAllLink = styled.a`
  width: 100%;
  margin: 5rem auto 0;
  padding: 1.5rem 2.5rem;
  border: 0.1rem solid rgba(34, 34, 34, 0.2);
  border-radius: 5rem;
  display: block;
  background-color: #fff;
  color: #222;
  font-size: 1.6rem;
  font-weight: 500;
  line-height: 2.16rem;
  letter-spacing: 0.1rem;
  text-align: center;
  text-transform: uppercase;

  ${minWidth.tablet`
    width: 29.4rem;
  `}
`
